export default __webpack_public_path__ + "static/media/1.b05c40fa.png";